import { render, staticRenderFns } from "./LayoutCreate.vue?vue&type=template&id=58bbf938&"
import script from "./LayoutCreate.vue?vue&type=script&lang=js&"
export * from "./LayoutCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports